import React from "react"
import PropTypes from "prop-types"

import ModernModal from "shared/components/ModernModal"
import SendForm from "../SendForm"

const SendModal = ({ productSelected, title, isOpen, onClose }) => {
  return (
    <ModernModal
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      renderFooter={false}
    >
      <SendForm onClose={onClose} productSelected={productSelected} />
    </ModernModal>
  )
}

SendModal.defaultProps = {
  productSelected: { assetTag: "" },
  title: "",
  isOpen: false,
  onClose: () => {}
}

SendModal.propTypes = {
  productSelected: PropTypes.shape({
    assetTag: PropTypes.string
  }),
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
}

export default SendModal



// WEBPACK FOOTER //
// ./src/scenes/ConsumptionProfile/components/SendModal/index.js